import { BookOpen } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function Resources() {
  const resources = [
    {
      title: "Anxiety Management Techniques",
      type: "Guide",
      shared: "2 days ago",
    },
    {
      title: "Mindfulness Meditation Audio",
      type: "Audio",
      shared: "5 days ago",
    },
    {
      title: "Cognitive Behavioral Therapy Worksheet",
      type: "Worksheet",
      shared: "1 week ago",
    },
    {
      title: "Sleep Hygiene Tips",
      type: "Article",
      shared: "1 week ago",
    },
  ];

  return (
    <div className="mx-auto w-full max-w-2xl">
      <div className="mb-6">
        <h2>Shared Resources</h2>
        <p className="text-muted-foreground">
          Access helpful materials and resources shared during your
          conversations.
        </p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-primary">
            <BookOpen className="size-5" />
            Shared Resources
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {resources.map((resource, index) => (
            <div
              key={index}
              className="flex cursor-pointer items-start justify-between rounded-lg border border-transparent p-2 transition-colors hover:border-primary/20 hover:bg-primary/5"
            >
              <div className="flex-1">
                <h4 className="leading-tight">{resource.title}</h4>
                <div className="mt-1 flex items-center gap-2">
                  <Badge
                    variant="secondary"
                    className="border-primary/20 bg-primary/10 text-xs text-primary"
                  >
                    {resource.type}
                  </Badge>
                  <span className="text-muted-foreground">•</span>
                  <span className="text-muted-foreground">
                    {resource.shared}
                  </span>
                </div>
              </div>
            </div>
          ))}
          <Button
            variant="outline"
            className="mt-4 w-full border-primary/20 hover:border-primary/40 hover:bg-primary/5"
          >
            View All Resources
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
